import { render } from "./UserStudyQuestions.vue?vue&type=template&id=3a551a4c&scoped=true"
import script from "./UserStudyQuestions.vue?vue&type=script&lang=js"
export * from "./UserStudyQuestions.vue?vue&type=script&lang=js"

import "./UserStudyQuestions.vue?vue&type=style&index=0&id=3a551a4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a551a4c"]])

export default __exports__